<meta name="viewport" content="width=1200">
<div class="MainExternalBody">
    <div class="animated fadeInDown DocumentContainer" *ngIf="showInvoiceVisualizer">

        <div class="PopUpTitleContainer">
          <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentInvoice.ID == null && !DocumentBodyLoading;">
            <span *ngIf="!IsStorno;">{{ 'Invoice' | translate }}</span>
            <span *ngIf="IsStorno;">{{ 'StornoInvoice' | translate }}</span>
            </p>
         </div> 
      
         <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
          <button mat-raised-button color="primary" class="VizualizeCommandButton" style="outline: none;" (click)="ExportInvoice(this.CurrentInvoice);">
            <i class="material-icons">file_copy</i>
            <span>{{ 'Receptions.Document.Export' | translate }}</span>
          </button>
      
          <button mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="PrintInvoice(this.CurrentInvoice);">
            <i class="material-icons">print</i>
            <span>{{ 'Receptions.Document.Print' | translate }}</span>
          </button>
      
          <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
        </div>
      
         <div class="PopUpBody" style="max-height: unset;" *ngIf="!CurrentInvoice.IsStorno">
            <p class="DocumentBodyCanceled" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;">{{this.parent.DocumentStatus}}</p>
      
            <table style="border: solid 1px #aaa;
            padding: 20px;
            font-weight: 400;
            margin-top: 2.5%;
            position: relative;
            margin-bottom: 2.5px;
            border-collapse: separate !important;
            border-radius: 4px;">
              <tbody>
                <tr>
                  <td style="border-radius: 3px;">
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 50%;max-height: 100px;float: left;">
                          <img alt="{{this.CurrentInvoice.Company.Name}}" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath != null;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath" style="max-width: 50%;max-height: 100%;"/>
                          <td style="width: 75%;
                          float: left;
                          font-size: 26px;
                          line-height: 30px;
                          font-weight: 700;
                          text-transform: uppercase;" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath == null;">{{this.CurrentInvoice.Company.Name}}</td>
                        </tr>
                        <tr style="width: 50%;float: left;">
                           <table style="width: 100%;float: left;">
                             <tbody>
                              <tr style="width: 50%;float: left;font-size: 26px;font-weight: 700;text-transform: uppercase;">
                                {{CurrentInvoice.DocType.Meaning}}
                              </tr>
                              <tr style="width: 50%;float: left;text-align: right;font-weight: 700;font-size: 22px;padding-right: 5px;">
                                {{CurrentInvoice.AccountingNumber.DisplayValue}}
                              </tr>
                             </tbody>
                           </table>
              
                            <table style="width: 100%;float: left;margin-top: 10px;">
                              <tbody>
                                <tr style="width: 50%;float: left;font-size: 13px;">
                                  {{ 'CreatingDate' | translate }}: {{CurrentInvoice.EventRegisterUIDate}}
                                </tr>
                                <tr style="width: 50%;float: left;text-align: right;font-size: 13px;padding-right: 5px;" *ngIf="CurrentInvoice.VATs.length == 1;">
                                  {{ 'VATRate' | translate }}: <span *ngFor="let v of CurrentInvoice.VATs">{{v.Percentage}}%</span>
                                </tr>
                              </tbody>
                            </table>
              
                           <table style="width: 100%;float: left;margin-top: 10px;">
                             <tbody>
                              <tr style="width: 100%;float: left;height: 40px;background: #254a91;border-radius: 3px;line-height: 40px;text-align: right;color: #fff;font-size: 20px;font-weight: 500;">
                                <td style="float: left;width: 100%;padding: 0;">
                                 <table style="width: 100%;">
                                   <tbody>
                                    <tr style="width: 50%;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                                      {{ 'TotalValue' | translate }}
                                    </tr>
                                    <tr style="width: 50%;float: left;font-size: 18px;text-align: right;padding-right: 10px;text-transform: uppercase;">
                                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                                      <span style="font-size: 14px;"> {{CurrentInvoice.Currency.Name}}</span>
                                    </tr>
                                   </tbody>
                                 </table>
                                </td>
                              </tr>
                             </tbody>
                           </table>
              
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                          <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                            <tr style="width: 60%;
                            float: left;
                            padding-left: 5px;
                            text-transform: uppercase;
                            font-weight: 500;
                            height: 30px;
                            line-height: 30px;
                            border-bottom: solid 2px #254a91;
                            margin-top: 10px;">{{ 'Supplier' | translate }}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-weight: 700;
                            font-size: 16px;">{{this.CurrentInvoice.Company.Name}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Company.VATNumber}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'RegCom' | translate }}: {{this.CurrentInvoice.Company.COCRegisterNr}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Company.Addresses[0].Country.Name}} 
                             {{this.CurrentInvoice.Company.Addresses[0].StateProvince}}
                             {{this.CurrentInvoice.Company.Addresses[0].City}}
                             {{this.CurrentInvoice.Company.Addresses[0].AddressLine}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{this.CurrentInvoice.Company.Banks[0].BankAccounts[0].Currency.Name}}) : {{this.CurrentInvoice.Company.Banks[0].BankAccounts[0].AccountNumber}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'Partners.PartnerWindow.Bank' | translate }}: {{this.CurrentInvoice.Company.Banks[0].Name}}</tr>
              
                          </td>
                        </tr>
                        <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                          <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                            <tr style="width: 60%;
                            float: left;
                            padding-left: 5px;
                            text-transform: uppercase;
                            font-weight: 500;
                            height: 30px;
                            line-height: 30px;
                            border-bottom: solid 2px #254a91;
                            margin-top: 10px;">{{ 'Client' | translate }}</tr> 
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-weight: 700;
                            font-size: 16px;">{{this.CurrentInvoice.Client.Name}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Client.VAT}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 0px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Client.BillingAddress.StateProvince}} {{this.CurrentInvoice.Client.BillingAddress.City}} {{this.CurrentInvoice.Client.BillingAddress.AddressLine}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 0px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'Country' | translate }}: {{this.CurrentInvoice.Client.BillingAddress.Country.Name}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 0px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'Login.Email' | translate }}: {{this.CurrentInvoice.Client.ContactInfo.Email}}</tr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;margin-top: 20px;height: 2px;background: #254a91;">
                          
                        </tr>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            {{ 'Receptions.Table.Nr' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                            {{ 'Receptions.Table.Name' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            {{ 'Receptions.Table.MU' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            {{ 'Receptions.Table.Qty' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;">
                            {{ 'Receptions.Table.Price' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;">
                            {{ 'Receptions.Table.Total' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            {{ 'Receptions.Table.VAT' | translate }}
                          </td>
                        </tr>
                        <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #254a91;">
                          
                        </tr>
              
                        <tr style="float: left;width: 100%;height: auto;min-height: 12px;padding-bottom: 10px;" *ngFor="let p of CurrentInvoice.Products; let i=index;" [ngClass]="{'GrayRow': i % 2 != 0}">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 7.5%;text-align: center;">
                            {{i + 1}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;height: auto;float: left;min-height: 12px;width: 30%;text-align: left;">
                            <p style="margin:0;margin-bottom:5px;">{{p.ProductInvoiceInfo.Name}}</p>
                            <p *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;" style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;">
                                {{row}}
                            </p>
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                            {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                            {{p.ProductInvoiceInfo.Quantity}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 17.5%;text-align: right;">
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>
              
                            <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                              Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}} 
                              <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                              <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{this.CurrentInvoice.Currency.Name}}</span>
                            </p>
                            <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null && p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">
                              Initial - {{p.ProductInvoiceInfo.Price.UIUnitPrice}} {{this.CurrentInvoice.Currency.Name}}
                            </p>
              
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 15%;text-align: right;">
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                            <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>
                          </td>
                        </tr>
              
                        <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #aaa;">
                          
                        </tr>
              
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            {{ 'InvoiceCreator' | translate }}:
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;text-transform: capitalize;">
                            {{this.CurrentInvoice.Details.Agent.Name}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                            Total:
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;background: #f6f6f6;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;background: #f6f6f6;">
                               <span>{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Integer}}</span>
                               <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Decimals}}</span> 
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                            <span>{{CurrentInvoice.Total.UITotalVAT.Integer}}</span>
                            <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalVAT.Decimals}}</span> 
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                            {{ 'TotalPayment' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                            <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                            <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                            <span> {{CurrentInvoice.Currency.Name}}</span>
                          </td>
                        
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                            {{ 'PaymentTerms' | translate }}:
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                             {{this.CurrentInvoice.PaymentDueDateUI}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                        
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                           
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                            <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" style="height: auto;
                            width: auto;
                            max-width: 100%;
                            max-height: 100px;"/>
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                          
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 30px;width: 25%;text-align: left;padding-left: 5px;">
                            {{this.CurrentInvoice.Details.Observations}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;background: #f6f6f6;">
                      <tbody>
                        <tr>
                          <td style="padding:5px;">
                            <tr style="float: left;width: 100%;height: auto;">
                              <td style="line-height: 12px;font-size: 12px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{this.CurrentInvoice.Company.Name}}
                              </td>
                            </tr>
                            <tr style="float: left;width: 100%;height: auto;">
                              <td style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{ 'Telephone' | translate }}: {{this.CurrentInvoice.Details.Agent.Phone}}; Email: {{this.CurrentInvoice.Details.Agent.Email}}
                              </td>
                            </tr>
                            <tr style="float: left;width: 100%;height: auto;" *ngFor="let b of this.CurrentInvoice.Company.Banks">
                              <td *ngFor="let a of b.BankAccounts" style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{a.Currency.Name}}) : {{a.AccountNumber}}
                              </td>
                            </tr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;" *ngIf="this.CurrentInvoice.Details.SignStampSubstituteRows.length > 0;">
                      <tbody>
                        <tr>
                          <td style="padding:5px;">
                            <tr style="float: left;width: 100%;height: auto;" *ngFor="let row of this.CurrentInvoice.Details.SignStampSubstituteRows">
                              <td style="line-height: 11px;font-size: 11px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{row}}
                              </td>
                            </tr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                        
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                           
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 50%;text-align: right;padding-right: 10px;">
                            {{'DocumentGeneratedBySoftware' | translate}}: <a href="https://www.foxcloud.ro" style="color: #254a91;">www.foxcloud.ro</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
         </div>
       
      </div>
</div>